<template>
  <div>
    <div v-if="isStoppedOrderingToday"
         style="text-align: center; background-color: #f8404f; line-height: 30px; height: 30px;">Our last order for the
      day has ended. If there's any enquiries please approach any of our staff. Thank you
    </div>
    <div v-if="isEndSoon && endMinutes < 60 && (endMinutes > 0 || endSeconds > 0)"
         style="text-align: center; background-color: #f8404f; line-height: 30px; height: 30px;">
      Order Ending: <strong>00:{{ endMinutes < 10 ? '0' + endMinutes : endMinutes }}:{{ endSeconds < 10 ? '0' + endSeconds: endSeconds }}</strong>
    </div>
    <div v-if="isStoppedOrderingAndHavingNextTimeslot && (openMinutes > 0 || openSeconds > 0)"
         style="text-align: center; background-color: #f8404f; line-height: 30px; height: 30px;">
      Order Starting: <strong>00:{{ openMinutes < 10 ? '0' + openMinutes : openMinutes }}:{{ openSeconds < 10 ? '0' + openSeconds: openSeconds }}</strong>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DineInTimeslot',
  data: function () {
    return {
      isStoppedOrderingToday: false,
      isStoppedOrderingAndHavingNextTimeslot: false,
      isEndSoon: false,
      openMinutes: null,
      openSeconds: null,
      endMinutes: null,
      endSeconds: null,
      reloading: false,
    }
  },
  computed: {
    ...mapGetters('dine_mode', [
      'dineTimes',
    ]),
    openDateTime: function () {
      let openDatetime = null
      if (this.dineTimes[0] === null && this.dineTimes[1] !== null) {
        openDatetime = this.dineTimes[1].datetime
      }

      return openDatetime
    },
    endDateTime: function () {
      let endDatetime = null
      if (this.dineTimes[2] !== null) {
        endDatetime = this.dineTimes[2].end_datetime
      } else if (this.dineTimes[0] !== null) {
        endDatetime = this.dineTimes[0].end_datetime
      }

      return endDatetime
    }

  },
  methods: {
    async fetchDineInTimeslots (callback) {
      await this.$store.dispatch('fetchDineInTimes')

      if (typeof callback === 'function') {
        callback();
      }
    },
    calculateStatus() {
      if (this.dineTimes[0] === null && this.dineTimes[1] === null) {
        this.isStoppedOrderingToday = true;
      }

      if (this.dineTimes[0] === null && this.dineTimes[1] !== null) {
        this.isStoppedOrderingAndHavingNextTimeslot = true;
      }

      if (this.dineTimes[0] !== null) {
        let endDatetime= null;
        if (this.dineTimes[2] !== null) {
          endDatetime = this.dineTimes[2].end_datetime
        } else {
          endDatetime = this.dineTimes[0].end_datetime;
        }

        if (((new Date(endDatetime).getTime() - new Date().getTime()) / 1000) <= 1800) {
          this.isEndSoon = true;
        }
      }
    },
    calculateMinutesAndSeconds () {
      if (this.endDateTime) {
        let diffMinutes = (new Date(this.endDateTime).getTime() - (new Date).getTime()) / 1000 / 60
        this.endMinutes = Math.floor(diffMinutes)
        this.endMinutes = this.endMinutes > 0 ? this.endMinutes : 0
        this.endSeconds = Math.ceil((diffMinutes - this.endMinutes) * 60)
        this.endSeconds = this.endSeconds > 0 ? this.endSeconds : 0
      }

      if (this.openDateTime) {
        let diffMinutes = (new Date(this.openDateTime).getTime() - (new Date).getTime()) / 1000 / 60
        this.openMinutes = Math.floor(diffMinutes)
        this.openMinutes = this.openMinutes > 0 ? this.openMinutes : 0
        this.openSeconds = Math.ceil((diffMinutes - this.openMinutes) * 60)
        this.openSeconds = this.openSeconds > 0 ? this.openSeconds : 0
      }

      if (
        (this.endMinutes === 0 && this.endSeconds === 0)
        || (this.openMinutes === 0 && this.openSeconds === 0)
      ) {
        console.log([
          this.endMinutes,
          this.endSeconds,
          this.openMinutes,
          this.openSeconds,
        ])

        if (this.reloading === false) {
          this.endMinutes = null;
          this.endSeconds = null;
          this.openMinutes = null;
          this.openSeconds = null;

          this.reloading = true
          console.log('will be reload.')
          // setTimeout(() => {
            this.fetchDineInTimeslots(() => {
              this.reloading = false;

              console.log('reloaded.');
            });
          // }, 1500)
        } else {
          console.log('reloading...')
        }
      }
    }
  },
  async created () {
    await this.fetchDineInTimeslots()

    // this.calculateMinutesAndSeconds()

    setInterval(() => {
      this.calculateMinutesAndSeconds()
    }, 1000)

    setTimeout(() => {
      this.calculateStatus();

    }, 1000)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/DineInTimeslot.vue